import type { ReactNode } from "react";

export function PolicySection({
    title,
    description,
    children,
    showDivider = true,
}: {
    title: string;
    description?: string;
    children: ReactNode;
    showDivider?: boolean;
}) {
    return (
        <section className={showDivider ? "border-t border-gray-200 pt-8 first:border-t-0 first:pt-0" : ""}>
            <div className="mb-6">
                <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
                {description ? <p className="mt-1 text-sm text-gray-500">{description}</p> : null}
            </div>
            {children}
        </section>
    );
}
